import React, { useEffect } from 'react';
import { translate } from 'react-jhipster';
import { toast } from 'react-toastify';
import { Button, Form, Input, Select } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { handleRegister, reset } from './register.reducer';
import { Container } from 'reactstrap';
import Title from 'antd/es/typography/Title';

export const RegisterPage = () => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  useEffect(
    () => () => {
      dispatch(reset());
    },
    [],
  );


  const handleValidSubmit = ({ username, email, firstPassword }) => {
    dispatch(handleRegister({ login: username, email, password: firstPassword }));
  };

  const successMessage = useAppSelector(state => state.register.successMessage);

  useEffect(() => {
    if (successMessage) {
      toast.success(translate(successMessage));
    }
  }, [successMessage]);

  const onFinish = (values: any) => {
    // eslint-disable-next-line no-console
    console.log('Received values of form: ', values);
  };

  const isFormDirty = () => {
    const fieldsValue = form.getFieldsValue();
    return Object.keys(fieldsValue).some(field => form.isFieldTouched(field));
  };

  return (
    <Container>
      <Form form={form} name="register" layout="vertical" onFinish={onFinish} scrollToFirstError>
        <Title level={3}>{`Thêm mới tài khoản`}</Title>
        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            {
              type: 'email',
              message: 'The input is not valid E-mail!',
            },
            {
              required: true,
              message: 'Please input your E-mail!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
          ]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="confirm"
          label="Confirm Password"
          dependencies={['password']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Please confirm your password!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The new password that you entered do not match!'));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="nickname"
          label="Nickname"
          tooltip="What do you want others to call you?"
          rules={[{ required: true, message: 'Please input your nickname!', whitespace: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="phone" label="Phone Number" rules={[{ required: true, message: 'Please input your phone number!' }]}>
          <Input style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="gender" label="Gender" rules={[{ required: true, message: 'Please select gender!' }]}>
          <Select
            placeholder="select your gender"
            options={[
              {
                label: 'Male',
                value: 0,
              },
              {
                label: 'Female',
                value: 1,
              },
              {
                label: 'Other',
                value: 2,
              },
            ]}
          ></Select>
        </Form.Item>
        <Form.Item className="d-flex justify-content-end">
          <Button type="primary" htmlType="submit">
            Register
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default RegisterPage;
